const isInvalidHttp = (url: string) => {
  return url?.includes('http') && !url?.match(/http(s?):\/\//)
}

const tryParseUrl = (url: string) => {
  try {
    return new URL(url)
  } catch (error) {
    console.error('error', `Failed to parse URL: ${url}`)
  }
}

export const isValidURL = (url: string) => {
  if (typeof url !== 'string' || isInvalidHttp(url)) {
    return false
  }

  const newUrl = tryParseUrl(url)?.origin || url

  const urlRegex =
    /^(https?:\/\/)([a-zA-Z0-9.-]+\.[a-zA-Z0-9-]{2,})(:[0-9]{1,5})?(\/[^\s?#]*)?(\?[^\s#]*)?(#[^\s]*)?$/

  return urlRegex.test(newUrl)
}

export const isDomainWithoutHttp = (url: string) => {
  if (typeof url !== 'string' || !isNaN(Number(url))) {
    return false
  }

  if (isInvalidHttp(url)) {
    return false
  }

  const urlWithHttp = tryParseUrl(`http://${url}`)?.origin || `http://${url}`

  const domainRegex =
    /^(https?:\/\/)?([\p{L}0-9.-]+\.[a-zA-Z0-9-]{2,})(:[0-9]{1,5})?(\/[^\s?#]*)?(\?[^\s#]*)?(#[^\s]*)?$/u

  return domainRegex.test(urlWithHttp)
}

export const isDomain = (url: string) => {
  if (typeof url !== 'string' || !isNaN(Number(url))) {
    return false
  }

  if (isInvalidHttp(url)) {
    return false
  }

  const urlWithHttp = url.includes('http') ? url : `http://${url}`
  const urlWithHttpParsed = tryParseUrl(urlWithHttp)?.origin || urlWithHttp

  const domainRegex =
    /^(https?:\/\/)?([\p{L}0-9.-]+\.[a-zA-Z0-9-]{2,})(:[0-9]{1,5})?(\/[^\s?#]*)?(\?[^\s#]*)?(#[^\s]*)?$/u

  return domainRegex.test(urlWithHttpParsed)
}

export const isBaseUrl = (url: string | null) => {
  if (typeof url !== 'string' || !isNaN(Number(url))) {
    return false
  }

  const urlWithHttp =
    tryParseUrl(url.includes('http') ? url : `http://${url}`)?.href || url

  const regex = /^(https?:\/\/)?([a-zA-Z0-9-]+\.)+[a-zA-Z0-9-]{2,}(:\d+)?\/?$/

  return regex.test(urlWithHttp)
}
